import { FC, useEffect, useRef, useState } from "react";
import moment from "moment/min/moment-with-locales";
import { useDispatch, useSelector } from "react-redux";

import { useBookingEnum } from "@enums/hooks.enum";
import { DateFormats } from "@enums/shared.enum";
import bookingSlice from "@slices/booking.slice";
import { RootState } from "@store/index";
import { toCapitalize } from "@utils/common.utils";

const Dates: FC = () => {
  const dispatch = useDispatch();

  const [bookingDates, setBookingDates] = useState<Array<string>>([]);

  const scrollRef = useRef<HTMLButtonElement>(null);

  const { calenderStartDate, selectedDate } = useSelector(
    (State: RootState) => State.booking
  );

  useEffect(() => {
    constructDates();
  }, [selectedDate]);

  useEffect(() => {
    scrollFocus();
  }, [selectedDate, bookingDates]);

  const changeSelectedDate = (date: string) => {
    dispatch(
      bookingSlice.actions.changeSelectedDate(
        moment(date).format(DateFormats.YMD)
      )
    );
  };

  const constructDates = () => {
    const width = window.innerWidth;
    const upcomingDays = [];
    for (
      let i = 0;
      i <
      (width > useBookingEnum.DeviceWidth
        ? useBookingEnum.MaxDatesOnStrip
        : useBookingEnum.MinDatesOnStrip);
      i++
    ) {
      upcomingDays.push(
        moment(calenderStartDate).clone().add(i, "days").format(DateFormats.YMD)
      );
    }
    setBookingDates(upcomingDays);
  };

  const scrollFocus = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

  return (
    <div className="fg-date-listing" data-testid="dates-test">
      {bookingDates.map((obj: string, index) => {
        return (
          <button
            className={`btn fg-btn fg-date-btn ${moment(selectedDate).isSame(obj) && "active"}`}
            data-testid="dates-button"
            key={index}
            onClick={() => {
              changeSelectedDate(obj);
            }}
            ref={moment(selectedDate).isSame(obj) ? scrollRef : null}
          >
            <span>
              {toCapitalize(
                moment(obj).format(DateFormats.WeekDay).substring(0, 2)
              )}
            </span>
            <span>
              {moment(obj).format(DateFormats.DayNumber)}.
              {moment(obj).format(DateFormats.MonthDay)}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default Dates;
